/* mb-pdp.js - VitaBrace productpagina
   Galerij (swipen, pijlen, teller, thumbnails), maattabel, bundelkeuze en de
   live prijs in de winkelwagenknop. Werkt samen met vitabrace-prototype.js,
   dat de variantkeuze afhandelt en het event mb:variant-change afvuurt. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------- geld */
  function formatMoney(cents, format) {
    var value = Number(cents || 0);
    var fmt = format || '&euro; {{amount_with_comma_separator}}';

    function group(number, decimals, thousands, decimalSep) {
      var num = (value / 100).toFixed(decimals);
      var parts = num.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 && parts[1] ? whole + decimalSep + parts[1] : whole;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, name) {
      switch (name) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_with_comma_separator': return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(value, 0, ' ', ',');
        case 'amount_with_period_and_space_separator': return group(value, 2, ' ', '.');
        default: return group(value, 2, '.', ',');
      }
    });
  }

  function decodeEntities(text) {
    var el = document.createElement('textarea');
    el.innerHTML = text || '';
    return el.value;
  }

  /* ------------------------------------------------------------- galerij */
  function initGallery(root) {
    var gallery = $('[data-mb2-gallery]', root);
    if (!gallery || gallery.mb2GalleryReady) return;

    var hero = $('[data-mb-gallery-hero]', gallery);
    if (!hero) return;
    gallery.mb2GalleryReady = true;

    var heroArea = $('.mb-pdp__hero', gallery);
    var thumbs = $$('[data-mb2-thumb]', gallery);
    var counter = $('[data-mb2-counter]', gallery);
    var thumbTrack = $('[data-mb2-thumbtrack]', gallery) || $('.mb-pdp__thumbs', gallery);
    var thumbPrev = $('[data-mb2-thumb-prev]', gallery);
    var thumbNext = $('[data-mb2-thumb-next]', gallery);
    var mobile = window.matchMedia('(max-width: 980px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var listeners = new AbortController();
    var resizeObserver;
    var navFrame = 0;
    var gesture = null;
    var index = 0;

    function on(target, type, callback, options) {
      if (target) target.addEventListener(type, callback, Object.assign({ signal: listeners.signal }, options));
    }

    function imageKey(src) {
      if (!src) return '';
      try { return new URL(src, window.location.href).pathname; }
      catch (_) { return src.split('?')[0]; }
    }

    function findImage(imageId, src) {
      var match = -1;
      if (imageId !== undefined && imageId !== null && imageId !== '') {
        match = thumbs.findIndex(function (btn) { return btn.dataset.imageId === String(imageId); });
      }
      if (match < 0 && src) {
        var key = imageKey(src);
        match = thumbs.findIndex(function (btn) { return imageKey(btn.dataset.src) === key; });
      }
      return match;
    }

    function thumbGap() {
      if (!thumbTrack) return 0;
      var styles = window.getComputedStyle(thumbTrack);
      return parseFloat(styles.columnGap || styles.gap || '0') || 0;
    }

    function thumbStep() {
      if (!thumbTrack || !thumbs.length) return 0;
      return thumbs[0].getBoundingClientRect().width + thumbGap();
    }

    function updateThumbNav() {
      if (!thumbTrack || !thumbPrev || !thumbNext) return;
      var maxScroll = Math.max(0, thumbTrack.scrollWidth - thumbTrack.clientWidth);
      thumbPrev.hidden = thumbTrack.scrollLeft <= 2;
      thumbNext.hidden = thumbTrack.scrollLeft >= maxScroll - 2;
    }

    function revealThumb(i, smooth) {
      if (!thumbTrack || !thumbs[i]) return;
      var btn = thumbs[i];
      // Cancel an older animation before measuring (e.g. rapid arrows or last -> first).
      thumbTrack.scrollTo({ left: thumbTrack.scrollLeft, behavior: 'instant' });
      var trackRect = thumbTrack.getBoundingClientRect();
      var btnRect = btn.getBoundingClientRect();
      // offsetLeft may be relative to the page; compare inside the scrolling track.
      var left = btnRect.left - trackRect.left - thumbTrack.clientLeft + thumbTrack.scrollLeft;
      var right = left + btnRect.width;
      var viewLeft = thumbTrack.scrollLeft;
      var viewRight = viewLeft + thumbTrack.clientWidth;
      var target = null;

      if (left < viewLeft - 1) {
        target = left;
      } else if (right > viewRight + 1) {
        target = right - thumbTrack.clientWidth;
      }

      if (target !== null) {
        thumbTrack.scrollTo({
          left: Math.max(0, Math.min(target, thumbTrack.scrollWidth - thumbTrack.clientWidth)),
          behavior: smooth === false || reducedMotion.matches ? 'instant' : 'smooth'
        });
      }

      window.cancelAnimationFrame(navFrame);
      navFrame = window.requestAnimationFrame(updateThumbNav);
    }

    function show(next, smooth) {
      if (!thumbs.length) return;
      var nextIndex = (next + thumbs.length) % thumbs.length;
      // Large jumps and wraparound reveal the matching thumbnail immediately.
      var animateThumb = smooth !== false && Math.abs(nextIndex - index) === 1;
      index = nextIndex;
      var btn = thumbs[index];

      if (btn.dataset.src) {
        // Keep every responsive image attribute in sync, including variant changes.
        hero.setAttribute('sizes', btn.dataset.sizes || '(max-width: 980px) 100vw, 52vw');
        if (btn.dataset.srcset) hero.setAttribute('srcset', btn.dataset.srcset);
        else hero.removeAttribute('srcset');
        hero.setAttribute('src', btn.dataset.src);
        if (btn.dataset.width) hero.setAttribute('width', btn.dataset.width);
        if (btn.dataset.height) hero.setAttribute('height', btn.dataset.height);
        hero.alt = btn.dataset.alt || '';
        hero.dataset.imageId = btn.dataset.imageId || '';
      }

      thumbs.forEach(function (x, i) {
        x.classList.toggle('is-active', i === index);
        x.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      if (counter) counter.textContent = (index + 1) + ' / ' + thumbs.length;
      revealThumb(index, animateThumb);
    }

    thumbs.forEach(function (btn, i) {
      on(btn, 'click', function () { resetGesture(); show(i); });
    });

    var heroPrev = $('[data-mb2-prev]', gallery);
    var heroNext = $('[data-mb2-next]', gallery);
    on(heroPrev, 'click', function () { show(index - 1); });
    on(heroNext, 'click', function () { show(index + 1); });

    on(heroArea, 'keydown', function (event) {
      if (event.target !== heroArea || event.altKey || event.ctrlKey || event.metaKey) return;
      var next;
      if (event.key === 'ArrowLeft') next = index - 1;
      else if (event.key === 'ArrowRight') next = index + 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = thumbs.length - 1;
      else return;
      event.preventDefault();
      show(next);
    });

    if (thumbTrack && thumbPrev && thumbNext && thumbs.length > 4) {
      on(thumbPrev, 'click', function () {
        thumbTrack.scrollBy({ left: -thumbStep(), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      });
      on(thumbNext, 'click', function () {
        thumbTrack.scrollBy({ left: thumbStep(), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      });
      on(thumbTrack, 'scroll', function () {
        window.cancelAnimationFrame(navFrame);
        navFrame = window.requestAnimationFrame(updateThumbNav);
      }, { passive: true });
    }

    /* Wisselt de galerij mee wanneer een variant een eigen foto heeft. */
    on(root, 'mb:variant-change', function (event) {
      var variant = event.detail || {};
      var match = findImage(variant.featured_image_id, variant.featured_image);
      resetGesture();
      if (match > -1) show(match);
    });

    /* Eén lichte afbeelding; horizontaal vegen laat verticaal scrollen en zoomen vrij. */
    function resetGesture() {
      var previous = gesture;
      gesture = null;
      if (!heroArea) return;
      heroArea.classList.remove('is-swiping');
      heroArea.style.removeProperty('--mb-pdp-swipe-offset');
      if (previous && heroArea.hasPointerCapture && heroArea.hasPointerCapture(previous.id)) {
        heroArea.releasePointerCapture(previous.id);
      }
    }

    if (heroArea && thumbs.length > 1) {
      gallery.setAttribute('data-mb2-swipe-ready', '');

      on(heroArea, 'pointerdown', function (event) {
        if (!mobile.matches || event.pointerType === 'mouse' || event.button > 0) return;
        if (!event.isPrimary || gesture) { resetGesture(); return; }
        if (event.target.closest('button, a, input, select, textarea, video, iframe, [role="button"]')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false };
        if (heroArea.setPointerCapture) {
          try { heroArea.setPointerCapture(event.pointerId); } catch (_) { resetGesture(); }
        }
      }, { passive: true });

      // A second finger anywhere on the page cancels this swipe (native pinch zoom).
      on(document, 'pointerdown', function (event) {
        if (gesture && event.pointerType !== 'mouse' && event.pointerId !== gesture.id) resetGesture();
      }, { capture: true, passive: true });

      on(heroArea, 'pointermove', function (event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        var dx = event.clientX - gesture.x;
        var dy = event.clientY - gesture.y;
        if (!gesture.horizontal && Math.abs(dy) > 12 && Math.abs(dy) >= Math.abs(dx)) {
          resetGesture();
          return;
        }
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.25) gesture.horizontal = true;
        if (gesture.horizontal) {
          heroArea.classList.add('is-swiping');
          heroArea.style.setProperty('--mb-pdp-swipe-offset', Math.max(-36, Math.min(36, dx * 0.18)) + 'px');
        }
      }, { passive: true });

      on(heroArea, 'pointerup', function (event) {
        if (!gesture || event.pointerId !== gesture.id) return;
        var dx = event.clientX - gesture.x;
        var dy = event.clientY - gesture.y;
        var threshold = Math.max(32, Math.min(64, heroArea.clientWidth * 0.1));
        var shouldChange = mobile.matches && Math.abs(dx) >= threshold && Math.abs(dx) > Math.abs(dy) * 1.25;
        resetGesture();
        if (shouldChange) show(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
      on(heroArea, 'pointercancel', resetGesture, { passive: true });
      on(heroArea, 'lostpointercapture', resetGesture, { passive: true });
      on(mobile, 'change', resetGesture);
    }

    function resized() {
      resetGesture();
      revealThumb(index, false);
      updateThumbNav();
    }
    if (thumbTrack && window.ResizeObserver) {
      resizeObserver = new ResizeObserver(resized);
      resizeObserver.observe(thumbTrack);
    } else {
      on(window, 'resize', resized, { passive: true });
    }

    if (thumbs.length) {
      var initialIndex = findImage(hero.dataset.imageId, hero.getAttribute('src'));
      var variantInput = $('form.mb-product-form input[name="id"]', root);
      var dataEl = $('[data-mb-variants-json]', root);
      if (variantInput && dataEl) {
        try {
          var variants = JSON.parse(dataEl.textContent);
          var selected = variants.find(function (variant) { return String(variant.id) === variantInput.value; });
          var selectedIndex = selected ? findImage(selected.featured_image_id, selected.featured_image) : -1;
          if (selectedIndex > -1) initialIndex = selectedIndex;
        } catch (_) {}
      }
      show(initialIndex > -1 ? initialIndex : 0, false);
      updateThumbNav();
    }

    gallery.mb2GalleryDestroy = function () {
      resetGesture();
      listeners.abort();
      if (resizeObserver) resizeObserver.disconnect();
      window.cancelAnimationFrame(navFrame);
      gallery.mb2GalleryReady = false;
      gallery.mb2GalleryDestroy = null;
    };
  }

  /* ----------------------------------------------------------- maattabel */
  function initSizePanel(root) {
    $$('[data-mb2-size-toggle]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ------------------------------------- bundels en prijs in de knop */
  function initBuyBox(root) {
    var form = $('form.mb-product-form', root);
    if (!form) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var button = $('[data-mb2-add]', root);
    var bundles = $$('[data-mb2-bundle]', root);
    var moneyFormat = decodeEntities(root.dataset.mb2MoneyFormat || '');
    var unitPrice = Number(root.dataset.mb2UnitPrice || 0);
    var available = root.dataset.mb2Available !== 'false';

    function selectedBundle() {
      return bundles.filter(function (b) { return b.classList.contains('is-selected'); })[0] || null;
    }

    function updateBundlePrices() {
      bundles.forEach(function (bundle) {
        var qty = Number(bundle.dataset.qty || 1);
        var discount = Number(bundle.dataset.discount || 0);
        var total = Math.round(unitPrice * qty * (1 - discount / 100));
        var saving = (unitPrice * qty) - total;
        var priceEl = $('[data-mb2-bundle-price]', bundle);
        var saveEl = $('[data-mb2-bundle-save]', bundle);
        bundle.dataset.total = String(total);
        if (priceEl) priceEl.textContent = formatMoney(total, moneyFormat);
        if (saveEl) {
          if (saving > 0) {
            saveEl.textContent = (saveEl.dataset.template || 'Je bespaart {saving}').replace('{saving}', formatMoney(saving, moneyFormat));
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
      });
    }

    function updateButton() {
      if (!button) return;
      if (!available) {
        button.textContent = button.dataset.soldOutLabel || 'Uitverkocht';
        button.disabled = true;
        return;
      }
      button.disabled = false;
      var label = button.dataset.availableLabel || 'In winkelwagen';
      var qty = Math.max(1, Number(qtyInput && qtyInput.value ? qtyInput.value : 1));
      var bundle = selectedBundle();
      var total;
      if (bundle && Number(bundle.dataset.qty || 1) === qty) {
        total = Number(bundle.dataset.total || 0);
      } else {
        total = unitPrice * qty;
      }
      button.textContent = total > 0 ? label + ' \u00b7 ' + formatMoney(total, moneyFormat) : label;
      root.dispatchEvent(new CustomEvent('mb:bundle-price-change', { detail: { total: total, qty: qty, available: available } }));
    }

    bundles.forEach(function (bundle) {
      bundle.addEventListener('click', function () {
        bundles.forEach(function (x) {
          x.classList.toggle('is-selected', x === bundle);
          x.setAttribute('aria-checked', String(x === bundle));
        });
        if (qtyInput) {
          qtyInput.value = bundle.dataset.qty || '1';
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateButton();
      });
    });

    if (qtyInput) qtyInput.addEventListener('change', updateButton);
    if (qtyInput) qtyInput.addEventListener('input', updateButton);

    /* vitabrace-prototype.js zet het knoplabel terug bij variantwissel,
       daarna hangen wij de actuele prijs er weer achter. */
    root.addEventListener('mb:variant-change', function (event) {
      var variant = event.detail || {};
      if (typeof variant.price === 'number') unitPrice = variant.price;
      available = variant.available !== false;
      updateBundlePrices();
      updateButton();
    });

    updateBundlePrices();
    updateButton();
  }


  /* ------------------------------------------------------ mobiele koopbalk */
  function initMobileBuyBar(root) {
    var bar = $('[data-mb-mobile-buy]', root);
    var form = $('form.mb-product-form', root);
    var mainButton = $('[data-mb2-add]', root);
    var buyrow = $('.mb-pdp__buyrow', root);
    if (!bar || !form || !mainButton || !buyrow) return;

    var price = $('[data-mb-mobile-price]', bar);
    var size = $('[data-mb-mobile-size]', bar);
    var button = $('[data-mb-mobile-add]', bar);
    var mobile = window.matchMedia('(max-width: 749px)');
    var moneyFormat = decodeEntities(root.dataset.mb2MoneyFormat || '');

    function syncBundlePrice(detail) {
      var selected = $('[data-mb2-bundle].is-selected', root);
      var total = detail && typeof detail.total === 'number' ? detail.total : Number(selected && selected.dataset.total ? selected.dataset.total : root.dataset.mb2UnitPrice || 0);
      if (price && total > 0) price.textContent = formatMoney(total, moneyFormat);
      if (button) {
        button.disabled = mainButton.disabled;
        button.textContent = mainButton.textContent;
      }
    }

    function updateSize() {
      if (!size) return;
      var firstGroup = $('[data-mb-option-group]', root);
      if (!firstGroup) return;
      var checked = firstGroup.querySelector('input[type="radio"]:checked');
      if (checked) size.textContent = checked.value;
    }

    function updateVisibility() {
      if (!mobile.matches) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        return;
      }
      var rect = buyrow.getBoundingClientRect();
      var show = rect.bottom < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (button) {
      button.addEventListener('click', function () {
        if (mainButton.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(mainButton);
        else mainButton.click();
      });
    }

    root.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-mb-option-group] input[type="radio"]')) updateSize();
    });

    root.addEventListener('mb:variant-change', function (event) {
      var variant = event.detail || {};
      if (button) {
        var available = variant.available !== false;
        button.disabled = !available;
      }
      updateSize();
      window.setTimeout(function () { syncBundlePrice(); }, 0);
    });

    root.addEventListener('mb:bundle-price-change', function (event) {
      syncBundlePrice(event.detail || {});
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    if (mobile.addEventListener) mobile.addEventListener('change', updateVisibility);
    updateSize();
    syncBundlePrice();
    updateVisibility();
  }

  function init() {
    $$('[data-mb2-pdp]').forEach(function (root) {
      if (root.mb2PdpReady) return;
      root.mb2PdpReady = true;
      initGallery(root);
      initSizePanel(root);
      initBuyBox(root);
      initMobileBuyBar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    $$('[data-mb2-gallery]', event.target).forEach(function (gallery) {
      if (gallery.mb2GalleryDestroy) gallery.mb2GalleryDestroy();
    });
  });
})();
